/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer } from '@/application';
import { SignInPageService } from '@/pages/SignIn';
import { logger as log } from '@common/logger';
import toast from 'react-hot-toast';

const MODULE_NAME = 'profile.machines.states.signInUser';

const getSrv = () => {
  return vappContainer.get<SignInPageService>(SignInPageService.displayName);
};

export const sendOTP = async (context: any, event: any) => {
  const currentState = 'SEND_OTP';
  const method = 'sendOTP';

  return new Promise(async (resolve, reject) => {
    try {
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const srv = getSrv();
      const content = await srv.sendOTP(event?.payload);
      log.log(MODULE_NAME, 'sendOTP=', content);
      if (content) {
        content?.message && toast.success(content?.message);
        return resolve({
          key: 'SEND_OTP_SUCCESS',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = content?.error;
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        toast.error(msg);
        return reject({
          key: 'SEND_OTP_FAILURE',
          value: content,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      toast.error(err?.message);
      return reject({
        key: 'SEND_OTP_FAILURE',
        value: 'Something went wrong please try again!',
      });
    }
  });
};
